import { InjectionToken } from '@angular/core';

export abstract class IPayment {

    url: string;
    path: string;

    abstract invoke(company: any, booking: any, purchase: any, client: any, description: any, fundCode: any, reference: any, price: any, vatOptOut: any): any;
    abstract query(paymentRef: any): any;
    abstract find(purchaseId: any, companyId: any): any;
    abstract vatExemption(companyId: any, serviceItems: any): any;
}